module.exports = __webpack_public_path__ + "static/media/  (116).0ae94a5e.jpg";